/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useShallow } from 'zustand/shallow';
import Center from '../../assets/styles/Center';
import FormContainer from '../../assets/styles/FormContainer';
import FormAuth from '../../components/FormAuth';
import GroupCheck from '../../components/GroupCheck';
import GroupInput from '../../components/GroupInput';
import Title from '../../components/Title';
import Verification from '../../components/Verification';
import useErrors from '../../hooks/useErrors';
import { useStore } from '../../stores';
import formatPhone from '../../utils/formatPhone';
import onlyPhone from '../../utils/onlyPhone';
import PhonesService from '../../services/PhonesService';

export default function V2() {
  const [number, setNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [numberAccept, setNumberAccept] = useState(false);
  const navigate = useNavigate();

  const { setUserData, setVerification, userData } = useStore(
    useShallow((state) => ({
      setUserData: state.setUserData,
      setVerification: state.setVerification,
      userData: state.userData,
    }))
  );

  const { setError, removeError, getErrorMessageByFieldName, errors } =
    useErrors();

  function handleNumber(e) {
    setNumber(formatPhone(e.target.value));

    removeError('number');
  }

  function handleNumberAccept(e) {
    setNumberAccept(e.target.checked);
  }

  async function onSubmit() {
    try {
      setLoading(true);

      if (!number) {
        setError({ field: 'number', message: 'O número é obrigátorio' });
        throw new Error('O número está vazio');
      }

      const numberFormat = `+55${onlyPhone(number)}`;

      await PhonesService.sendPhone(numberFormat);

      const body = { ...userData, phone: numberFormat, numberAccept };

      setUserData(body);

      setVerification(3);
      navigate('/modelregister/v3');
    } catch (error) {
      const message = error?.response?.data?.error;

      setError({ field: 'number', message });
    } finally {
      setLoading(false);
    }
  }

  const isFormValid = Boolean(number) && errors.length === 0;

  return (
    <FormContainer>
      <Center className="center">
        <Verification v={2} />

        <Title
          title="Cadastre seu número"
          subtitle="Informe seu número de telefone"
        />

        <FormAuth
          onSubmit={onSubmit}
          buttonTitle="Continuar"
          next
          isLoading={loading}
          formValid={isFormValid}
        >
          <GroupInput error={getErrorMessageByFieldName('number')}>
            <label>Telefone*</label>
            <input
              type="text"
              placeholder="Digite seu número"
              value={number}
              onChange={handleNumber}
            />
          </GroupInput>

          <GroupCheck check={numberAccept}>
            <input
              type="checkbox"
              checked={numberAccept}
              onChange={handleNumberAccept}
            />
            <label>Aceito receber mensagens de promoções</label>
          </GroupCheck>
        </FormAuth>
      </Center>
    </FormContainer>
  );
}
